import { useEffect } from 'react'

import { useIsStandalone } from '~/hooks/useIsStandalone'
import { sendTrackingData } from '~/utils/tracking'

export const usePWATracking = () => {
  const isStandalone = useIsStandalone()

  useEffect(() => {
    if (isStandalone) {
      sendTrackingData('pwaStandaloneOpened')
    }
  }, [isStandalone])

  // appinstalled fires on Android/Chrome when the user installs the PWA
  useEffect(() => {
    const handler = () => sendTrackingData('pwaInstalled')
    window.addEventListener('appinstalled', handler)
    return () => window.removeEventListener('appinstalled', handler)
  }, [])
}
